import styles from './DoorToDoor.module.css'
import React, { useEffect, useState } from "react";
import { getWorkerJobTravelInfo, recalculateCommutingTime } from "../../../../../api/apiCall";
import { useAuth } from "../../../../../auth/auth";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Button } from '@mui/material';

const DoorToDoorTable = ({shiftData}: any) => {
    const {state} = useAuth();
    const [travelInfo, setTravelInfo] = useState<any>([]);

    const getTravelInfo = async () => {
        const response = await getWorkerJobTravelInfo(state.user?.token, shiftData.id);
        setTravelInfo(response?.data);
    };

    const reCalculateDoorToDoor = async () => {
        await recalculateCommutingTime(state.user?.token, {
            jobId: shiftData.id,
            jobPostCode: shiftData.postCode,
        })
    }

    useEffect(() => {
        getTravelInfo();
    }, []);

    return (
        <div className={styles.tableContainer}>
            <div className={styles.button}>
                <Button onClick={reCalculateDoorToDoor}>Recalculate Commute</Button>
            </div>
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th>Full Name</th>
                        <th>From - To</th>
                        <th>Miles</th>
                        <th>Duration</th>
                    </tr>
                </thead>
                <tbody>
                    {travelInfo.map((worker: any) => (
                        <>
                            <tr>
                                <td rowSpan={2} style={{borderLeft: '1px solid #c2b8b8'}}>{worker.fullName}</td>
                                <td>{worker.homePostCode} <FontAwesomeIcon icon={faArrowRight} /> {worker.jobPostCode}</td>
                                <td>{worker.distanceHomeToJob}</td>
                                <td>{worker.durationHomeToJob}</td>
                            </tr>
                            <tr>
                                <td> {worker.homePostCode} <FontAwesomeIcon icon={faArrowLeft} /> {worker.jobPostCode}</td>
                                <td>{worker.distanceJobToHome}</td>
                                <td>{worker.durationJobToHome}</td>
                            </tr>
                        </>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default DoorToDoorTable;